import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import PopularServices from "@/components/PopularServices";
import SolarHighlight from "@/components/SolarHighlight";
import Pillars from "@/components/Pillars";
import Gallery from "@/components/Gallery";
import WhyChoose from "@/components/WhyChoose";
import GrowWith from "@/components/GrowWith";
import Reviews from "@/components/Reviews";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

const OG_IMAGE = "https://customer-assets-0z36b82j.emergentagent.net/job_e11fd24c-7b48-4e17-adcd-1af3744f40d4/artifacts/6221c013a817eb03_file_000000005b84822fa0d34d662b8734ac.png";

export default function Landing() {
  return (
    <>
      <Seo
        title="DuroTech28 — Low Voltage Specialist in Dallas–Fort Worth"
        description="One company for physical + digital infrastructure in Dallas–Fort Worth: TV mounting, smart homes, CCTV, structured cabling, fiber, websites & AI automation."
        canonical="https://durotech28.me/"
        ogImage={OG_IMAGE}
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <PopularServices />
        <SolarHighlight />
        <Pillars />
        <Gallery />
        <WhyChoose />
        <Reviews />
        <GrowWith />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
